/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * level of escalation:
 *   * LEVEL1
 *   * LEVEL2
 *   * LEVEL3
 *   * LEVEL4
 *   * LEVEL5
 *   * LEVEL6
 *   * LEVEL7
 *   * LEVEL8
 *   * LEVEL9
 *   * LEVEL10
 */
export enum EscalationLevel {
  LEVEL1 = 'LEVEL1',
  LEVEL2 = 'LEVEL2',
  LEVEL3 = 'LEVEL3',
  LEVEL4 = 'LEVEL4',
  LEVEL5 = 'LEVEL5',
  LEVEL6 = 'LEVEL6',
  LEVEL7 = 'LEVEL7',
  LEVEL8 = 'LEVEL8',
  LEVEL9 = 'LEVEL9',
  LEVEL10 = 'LEVEL10'
}
